import { createAction, props } from "@ngrx/store";

export enum EchoActionType {
    ECHO_SET_SILT_VALUE = '@form/ECHO_SET_SILT_VALUE',
}

export const setEchoSiltValue = createAction(EchoActionType.ECHO_SET_SILT_VALUE, props<{ value: number }>());
